import { render, staticRenderFns } from "./TheThgAdminList.vue?vue&type=template&id=401cd874&scoped=true"
import script from "./TheThgAdminList.vue?vue&type=script&lang=ts"
export * from "./TheThgAdminList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cd874",
  null
  
)

export default component.exports